import HexButton from "./HexButton";
import Jinx from './Jinx';
import Logo from "./Logo";
import PropTypes from 'prop-types';
import React from "react";
import Slant from './Slant';

const InlineSVG = props => {
  switch (props.name) {
    case "hexButton":
      return <HexButton {...props} />;
    case "logo":
      return <Logo {...props} />;
    case "slant":
      return <Slant {...props} />;
    case "jinx":
      return <Jinx {...props} />;
    default: 
      console.error("you tried to import a icon that is not listed in /icons");
      return null;
  }
};
InlineSVG.propTypes = {
    name: PropTypes.string
};
export default InlineSVG;
